import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import profileFiller from "../../images/empty.jpg";

export const photoUrl = (photo) =>
  photo ? `${process.env.REACT_APP_IMAGES_DATA_RESOURCES_URL}/${photo}` : profileFiller;

/** Re-render every `intervalMs` so relative times ("3m waiting") stay current. */
export function useNow(intervalMs = 30000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}

export function timeAgo(date, now = Date.now()) {
  if (!date) return "";
  const seconds = Math.max(0, Math.round((now - new Date(date).getTime()) / 1000));
  if (seconds < 60) return "just now";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.round(hours / 24)}d`;
}

export const formatTime = (date) =>
  date ? new Date(date).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) : "";

export const STATUS_LABELS = {
  waiting: "Waiting",
  active: "Active",
  resolved: "Resolved",
  missed: "Missed",
  abandoned: "Abandoned",
};

export const confirmAction = (title, text, confirmButtonText = "Yes") =>
  Swal.fire({
    title,
    text,
    icon: "question",
    showCancelButton: true,
    confirmButtonText,
    confirmButtonColor: "#9d0001",
  }).then((result) => result.isConfirmed);

export const showSupportError = (message) =>
  Swal.fire({
    title: "Customer support",
    text: message || "Something went wrong. Please try again.",
    icon: "error",
    confirmButtonColor: "#d33",
  });
